/**
 * Which citation the reader pane is showing right now.
 *
 * The Sources list under every answer marks the opened source (a champagne
 * rail, not a fill) so the reader can see which entry the document beside
 * them belongs to. Provided once by the research surface; outside it the
 * value is null and nothing is marked.
 */

import { createContext, useContext } from 'react';
import { ResearchCitation } from '../types';

export const ActiveCitationContext = createContext<ResearchCitation | null>(null);

export function useActiveCitation(): ResearchCitation | null {
  return useContext(ActiveCitationContext);
}

/** The document a citation points at - stable across re-hydrated turns. */
function documentKey(c: Partial<ResearchCitation>): string {
  return String(c.document_uuid || c.blob_path || c.url || c.file_name || c.title || '').trim();
}

/** True when `candidate` is the citation the reader pane has open. */
export function isActiveCitation(
  candidate: ResearchCitation,
  active: ResearchCitation | null
): boolean {
  if (!active) return false;
  if (candidate === active) return true;
  if (candidate.id && active.id) return candidate.id === active.id;
  const key = documentKey(candidate);
  return !!key && key === documentKey(active) && candidate.number === active.number;
}
